import { render, staticRenderFns } from "./BaseHoneycomb.vue?vue&type=template&id=5f1768b2&scoped=true&"
import script from "./BaseHoneycomb.vue?vue&type=script&lang=js&"
export * from "./BaseHoneycomb.vue?vue&type=script&lang=js&"
import style0 from "./BaseHoneycomb.vue?vue&type=style&index=0&id=5f1768b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1768b2",
  null
  
)

export default component.exports